/**
 * PocketFiler - Vietnamese (vi) Translation File
 * Tiếng Việt - Auto-translated from English, formal register
 */

const vi = {
  "nav.login": "Đăng nhập",
  "nav.signup": "Bắt đầu",
  "nav.logout": "Đăng xuất",
  "nav.dashboard": "Bảng điều khiển",
  "nav.virtualOffices": "Văn phòng ảo",
  "nav.clients": "Liên hệ",
  "nav.contacts": "Liên hệ",
  "nav.deals": "Giao dịch",
  "nav.documents": "Tài liệu",
  "nav.messages": "Tin nhắn",
  "nav.settings": "Cài đặt",
  "nav.companyProfile": "Hồ sơ công ty",
  "nav.products": "Sản phẩm",
  "nav.directory": "Danh bạ",
  "nav.invoices": "Hóa đơn",
  "nav.templates": "Mẫu",
  "nav.tasks": "Nhiệm vụ",
  "nav.meetings": "Cuộc họp",
  "nav.analytics": "Phân tích",
  "nav.rfq": "Yêu cầu báo giá",
  "nav.developerSettings": "API Keys & Webhooks",
  "nav.events": "Sự kiện",
  "landing.badge": "Nền tảng giao dịch hỗ trợ AI",
  "landing.hero.title": "Cần hợp đồng?",
  "landing.hero.titleHighlight": "AI viết giúp bạn.",
  "landing.hero.subtitle": "Hợp đồng AI thông minh, quy trình tài liệu thông minh, và dịch thuật AI thực sự cho văn bản, cuộc gọi video, và hợp đồng—được xây dựng cho dịch vụ chuyên nghiệp và thương mại toàn cầu.",
  "landing.hero.cta.start": "Bắt đầu miễn phí",
  "landing.hero.cta.demo": "Xem cách hoạt động",
  "landing.hero.trust": "Gói miễn phí. Không cần thẻ tín dụng. Hỗ trợ 11 ngôn ngữ.",
  "landing.socialProof": "Được tin tưởng bởi hơn 500 doanh nghiệp tại 40 quốc gia",
  "landing.useCases.title": "Được xây dựng cho các giao dịch đa ngôn ngữ, độ tin cậy cao",
  "landing.useCases.subtitle": "",
  "landing.useCases.professional.title": "Dịch vụ chuyên nghiệp",
  "landing.useCases.professional.subtitle": "Bảo hiểm, Bất động sản, Cho vay",
  "landing.useCases.professional.desc": "Mời khách hàng tải lên tài liệu với sự hỗ trợ của AI, theo dõi mọi tương tác trong Văn phòng ảo bảo mật, và tạo hợp đồng điện tử song ngữ—tất cả từ một không gian làm việc.",
  "landing.useCases.globalTrade.title": "Thương mại toàn cầu & Thương mại xuyên biên giới",
  "landing.useCases.globalTrade.desc": "Tìm nguồn cung cấp nước ngoài không có rào cản ngôn ngữ và không cần hội chợ thương mại đắt đỏ. Quản lý tài liệu tuân thủ trong phòng giao dịch chuyên dụng với dịch thuật thời gian thực.",
  "landing.useCases.personal.title": "Giao dịch cá nhân giá trị cao",
  "landing.useCases.personal.desc": "Hoàn thành các giao dịch quan trọng một lần như xe cộ, thiết bị, hoặc bất động sản với hồ sơ rõ ràng, hợp đồng AI, và liên kết bảo mật đơn giản để chia sẻ tài liệu.",
  "landing.howItWorks.title": "PocketFiler hoạt động như thế nào cho mọi giao dịch",
  "landing.howItWorks.subtitle": "",
  "landing.howItWorks.dealRooms.title": "Phòng giao dịch & Hợp đồng",
  "landing.howItWorks.dealRooms.desc": "Mỗi giao dịch có một phòng riêng biệt với dòng thời gian, tin nhắn, tài liệu, và bản thảo hợp đồng được AI tạo mà bạn có thể xem xét và hoàn thiện.",
  "landing.howItWorks.translation.title": "Dịch thuật AI tự động",
  "landing.howItWorks.translation.desc": "Tin nhắn và nội dung quan trọng được dịch ngay lập tức giữa các bên, để người mua, người bán, và khách hàng có thể giao tiếp bằng ngôn ngữ của họ.",
  "landing.howItWorks.documents.title": "Tài liệu thông minh",
  "landing.howItWorks.documents.desc": "Khách hàng tải lên tài liệu từ điện thoại; AI trích xuất các trường quan trọng, kiểm tra chất lượng, và đánh dấu vấn đề trước khi chúng làm chậm giao dịch.",
  "landing.howItWorks.concierge.title": "AI Concierge",
  "landing.howItWorks.concierge.desc": "Trợ lý AI của bạn học hỏi doanh nghiệp của bạn, thiết lập các văn phòng ảo phù hợp, và cấu hình danh sách kiểm tra tài liệu cho từng loại giao dịch.",
  "landing.cta.title": "Bắt đầu hoàn thành các giao dịch đa ngôn ngữ ngay hôm nay",
  "landing.cta.subtitle": "Tham gia các doanh nghiệp xử lý giao dịch quan trọng bằng 11 ngôn ngữ",
  "landing.cta.button": "Tạo tài khoản miễn phí",
  "landing.cta.secondary": "Xem phòng giao dịch mẫu",
  "landing.footer.tagline": "Các giao dịch quan trọng trở nên đơn giản.",
  "language.picker.title": "Chọn ngôn ngữ của bạn",
  "language.picker.subtitle": "Chúng tôi sẽ hiển thị tất cả hướng dẫn, tin nhắn và hợp đồng bằng ngôn ngữ này. Những người khác có thể chọn ngôn ngữ của riêng họ; AI sẽ xử lý việc dịch thuật cho bạn.",
  "language.picker.continue": "Tiếp tục",
  "language.picker.playSample": "Phát mẫu",
  "language.picker.playing": "Đang phát...",
  "language.picker.confirmation": "Bạn đã chọn {language}. Chúng tôi sẽ hiển thị mọi thứ bằng ngôn ngữ này cho bạn. Các bên khác có thể chọn ngôn ngữ của riêng họ; PocketFiler dịch tin nhắn, tài liệu và hợp đồng để mọi người đều hiểu.",
  "language.toast.saved": "Đã lưu ngôn ngữ! Để thay đổi, vào Cài đặt trong hồ sơ của bạn.",
  "language.confirm.title": "Xác nhận ngôn ngữ của bạn",
  "language.confirm.subtitle": "Ngôn ngữ này sẽ được sử dụng cho tất cả giao diện, tin nhắn và hợp đồng.",
  "language.confirm.change": "Thay đổi ngôn ngữ",
  "language.confirm.continue": "Tiếp tục với",
  "language.confirm.chineseNote": "Lưu ý: Bạn đã chọn Tiếng Trung Giản thể (简体中文). Nếu bạn muốn Tiếng Trung Phồn thể, vui lòng thay đổi lựa chọn.",
  "auth.login.title": "Chào mừng trở lại",
  "auth.login.subtitle": "Đăng nhập vào tài khoản PocketFiler của bạn",
  "auth.login.email": "Email",
  "auth.login.password": "Mật khẩu",
  "auth.login.submit": "Đăng nhập",
  "auth.login.noAccount": "Chưa có tài khoản?",
  "auth.login.signupLink": "Đăng ký",
  "auth.login.error": "Email hoặc mật khẩu không hợp lệ",
  "auth.signup.title": "Tạo tài khoản của bạn",
  "auth.signup.subtitle": "Bắt đầu hoàn thành giao dịch bằng bất kỳ ngôn ngữ nào",
  "auth.signup.name": "Họ và tên",
  "auth.signup.email": "Email",
  "auth.signup.password": "Mật khẩu",
  "auth.signup.confirmPassword": "Xác nhận mật khẩu",
  "auth.signup.companyName": "Tên công ty",
  "auth.signup.companyType": "Loại tài khoản",
  "auth.signup.accountType": "Loại tài khoản",
  "auth.signup.submit": "Tạo tài khoản",
  "auth.signup.hasAccount": "Đã có tài khoản?",
  "auth.signup.loginLink": "Đăng nhập",
  "auth.signup.terms": "Bằng cách đăng ký, bạn đồng ý với Điều khoản dịch vụ và Chính sách bảo mật của chúng tôi.",
  "auth.signup.passwordsDoNotMatch": "Mật khẩu không khớp",
  "auth.signup.passwordTooShort": "Mật khẩu phải có ít nhất 8 ký tự",
  "auth.signup.success": "Tạo tài khoản thành công!",
  "dashboard.title": "Bảng điều khiển",
  "dashboard.welcome": "Chào mừng trở lại, {name}",
  "dashboard.aiSummary.title": "Tóm tắt AI",
  "dashboard.aiSummary.generating": "Đang tạo tóm tắt...",
  "dashboard.stats.totalDeals": "Tổng giao dịch",
  "dashboard.stats.activeDeals": "Giao dịch đang hoạt động",
  "dashboard.stats.totalClients": "Tổng liên hệ",
  "dashboard.stats.totalContacts": "Tổng liên hệ",
  "dashboard.stats.documentsProcessed": "Tài liệu đã xử lý",
  "dashboard.recentDeals.title": "Giao dịch gần đây",
  "dashboard.recentDeals.viewAll": "Xem tất cả",
  "dashboard.recentDeals.empty": "Chưa có giao dịch nào. Tạo giao dịch đầu tiên để bắt đầu.",
  "dashboard.recentClients.title": "Liên hệ gần đây",
  "dashboard.recentContacts.title": "Liên hệ gần đây",
  "dashboard.recentClients.viewAll": "Xem tất cả",
  "dashboard.recentContacts.viewAll": "Xem tất cả",
  "dashboard.recentClients.empty": "Chưa có liên hệ nào. Mời liên hệ đầu tiên để bắt đầu.",
  "dashboard.recentContacts.empty": "Chưa có liên hệ nào. Mời liên hệ đầu tiên để bắt đầu.",
  "dashboard.quickActions.title": "Hành động nhanh",
  "dashboard.quickActions.createDeal": "Tạo giao dịch",
  "dashboard.quickActions.inviteClient": "Thêm liên hệ",
  "dashboard.quickActions.inviteContact": "Thêm liên hệ",
  "dashboard.quickActions.createOffice": "Tạo văn phòng ảo",
  "offices.title": "Văn phòng ảo",
  "offices.subtitle": "Tổ chức doanh nghiệp theo loại dịch vụ",
  "offices.create": "Tạo văn phòng ảo",
  "offices.empty.title": "Chưa có văn phòng ảo nào",
  "offices.empty.desc": "Tạo văn phòng ảo đầu tiên để tổ chức các giao dịch và liên hệ của bạn.",
  "offices.card.clients": "{count} liên hệ",
  "offices.card.contacts": "{count} liên hệ",
  "offices.card.deals": "{count} giao dịch",
  "offices.card.checklist": "Mục danh sách kiểm tra",
  "offices.checklist": "Danh sách kiểm tra tài liệu",
  "offices.noChecklist": "Không yêu cầu tài liệu",
  "offices.dialog.title": "Tạo văn phòng ảo",
  "offices.dialog.desc": "Thiết lập không gian làm việc mới cho một loại dịch vụ cụ thể",
  "offices.dialog.name": "Tên văn phòng",
  "offices.dialog.namePlaceholder": "ví dụ: Bồi thường bảo hiểm, Bán bất động sản",
  "offices.dialog.type": "Loại văn phòng",
  "offices.dialog.description": "Mô tả",
  "offices.dialog.descriptionPlaceholder": "Mô tả văn phòng này xử lý gì...",
  "offices.dialog.checklist": "Danh sách kiểm tra tài liệu",
  "offices.dialog.checklistHelp": "Danh sách kiểm tra được AI tạo cho các tài liệu bắt buộc",
  "offices.dialog.addItem": "Thêm mục",
  "offices.dialog.generateChecklist": "Tạo bằng AI",
  "offices.dialog.creating": "Đang tạo...",
  "offices.dialog.create": "Tạo văn phòng",
  "offices.form.name": "Tên văn phòng",
  "offices.form.namePlaceholder": "ví dụ: Dịch vụ bảo hiểm, Bất động sản, v.v.",
  "offices.form.description": "Mô tả",
  "offices.form.descPlaceholder": "Văn phòng này sẽ xử lý loại giao dịch nào?",
  "offices.form.checklistPlaceholder": "Thêm tài liệu bắt buộc...",
  "offices.ai.title": "Thiết lập hỗ trợ AI",
  "offices.ai.desc": "Để AI Concierge của chúng tôi giúp bạn thiết lập văn phòng ảo hoàn hảo bằng cách hỏi về nhu cầu kinh doanh của bạn.",
  "offices.ai.manual": "Thiết lập thủ công",
  "offices.ai.start": "Bắt đầu thiết lập AI",
  "offices.ai.startOnboarding": "Giúp tôi thiết lập văn phòng ảo",
  "offices.ai.suggestion": "Gợi ý AI",
  "offices.ai.acceptSuggestion": "Chấp nhận & Tạo văn phòng",
  "offices.ai.inputPlaceholder": "Nhập phản hồi của bạn...",
  "clients.title": "Danh bạ",
  "contacts.title": "Danh bạ",
  "clients.subtitle": "Quản lý danh bạ và lời mời của bạn",
  "contacts.subtitle": "Quản lý danh bạ và lời mời của bạn",
  "clients.invite": "Thêm liên hệ",
  "contacts.invite": "Thêm liên hệ",
  "clients.empty.title": "Chưa có liên hệ nào",
  "contacts.empty.title": "Chưa có liên hệ nào",
  "clients.empty.desc": "Thêm liên hệ đầu tiên để bắt đầu.",
  "contacts.empty.desc": "Thêm liên hệ đầu tiên để bắt đầu.",
  "clients.table.name": "Tên",
  "clients.table.client": "Liên hệ",
  "contacts.table.contact": "Liên hệ",
  "clients.table.contact": "Liên hệ",
  "clients.table.office": "Văn phòng",
  "clients.table.language": "Ngôn ngữ",
  "clients.table.status": "Trạng thái",
  "clients.table.actions": "Thao tác",
  "clients.status.invited": "Đã mời",
  "clients.status.active": "Hoạt động",
  "clients.status.completed": "Hoàn thành",
  "clients.dialog.title": "Thêm liên hệ mới",
  "contacts.dialog.title": "Thêm liên hệ mới",
  "clients.dialog.name": "Tên liên hệ",
  "contacts.dialog.name": "Tên liên hệ",
  "clients.dialog.email": "Địa chỉ email",
  "clients.dialog.phone": "Số điện thoại",
  "clients.dialog.office": "Văn phòng ảo",
  "clients.dialog.language": "Ngôn ngữ ưa thích",
  "clients.dialog.sending": "Đang gửi lời mời...",
  "clients.dialog.send": "Gửi lời mời",
  "clients.toast.invited": "Đã thêm liên hệ: {name}",
  "contacts.toast.invited": "Đã thêm liên hệ: {name}",
  "clients.toast.deleted": "Đã xóa liên hệ",
  "contacts.toast.deleted": "Đã xóa liên hệ",
  "clients.toast.linkCopied": "Đã sao chép liên kết",
  "contacts.toast.linkCopied": "Đã sao chép liên kết",
  "clients.invite.step1Title": "Thêm liên hệ mới",
  "contacts.invite.step1Title": "Thêm liên hệ mới",
  "clients.invite.step2Title": "Xem trước lời mời",
  "clients.invite.step3Title": "Đã gửi lời mời!",
  "clients.invite.step1Desc": "Nhập thông tin liên hệ",
  "contacts.invite.step1Desc": "Nhập thông tin liên hệ",
  "clients.invite.step2Desc": "Xem lại và tùy chỉnh thông điệp mời",
  "clients.invite.step3Desc": "Chia sẻ liên kết mời với khách hàng",
  "clients.invite.nameLabel": "Tên liên hệ",
  "contacts.invite.nameLabel": "Tên liên hệ",
  "clients.invite.namePlaceholder": "ví dụ: Nguyễn Văn A",
  "clients.invite.contactMethod": "Phương thức liên hệ",
  "clients.invite.phone": "Số điện thoại",
  "clients.invite.customNote": "Ghi chú tùy chỉnh",
  "clients.invite.customNotePlaceholder": "Ghi chú đặc biệt về liên hệ này...",
  "contacts.invite.customNotePlaceholder": "Ghi chú đặc biệt về liên hệ này...",
  "clients.invite.previewMessage": "Xem trước thông điệp",
  "clients.invite.aiGenerated": "Thông điệp mời do AI tạo",
  "clients.invite.messagePreview": "Xem trước thông điệp",
  "clients.invite.messageEditHint": "Bạn có thể chỉnh sửa thông điệp này trước khi gửi",
  "clients.invite.documentsRequested": "Tài liệu được yêu cầu",
  "clients.invite.regenerate": "Tạo lại thông điệp",
  "clients.invite.sendInvite": "Gửi lời mời",
  "clients.invite.linkCreated": "Đã tạo liên kết mời!",
  "clients.invite.linkCopiedToClipboard": "Liên kết đã được sao chép vào clipboard",
  "clients.invite.shareLink": "Chia sẻ liên kết này với liên hệ qua email, SMS hoặc trực tiếp",
  "contacts.invite.shareLink": "Chia sẻ liên kết này với liên hệ qua email, SMS hoặc trực tiếp",
  "clients.invite.inviteAnother": "Mời thêm",
  "clients.invite.success": "Đã mời khách hàng!",
  "clients.invite.linkCopied": "Đã sao chép liên kết mời!",
  "clients.invite.yourAgent": "Đại lý của bạn",
  "clients.invite.defaultOffice": "Văn phòng của chúng tôi",
  "clients.nav.myClients": "Khách hàng của tôi",
  "clients.nav.joinedOrgs": "Tổ chức đã tham gia",
  "clients.table.organization": "Tổ chức",
  "clients.table.joinedDate": "Ngày tham gia",
  "clients.joined.empty.title": "Chưa tham gia tổ chức nào",
  "clients.joined.empty.desc": "Bạn chưa tham gia tổ chức nào. Hãy yêu cầu họ mời bạn vào không gian làm việc PocketFiler.",
  "contacts.actions.title": "Liên hệ {name}",
  "contacts.actions.call": "Gọi điện",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.actions.sms": "Tin nhắn",
  "contacts.actions.email": "Email",
  "contacts.actions.message": "Gửi tin nhắn trong ứng dụng",
  "contacts.actions.noPhone": "Không có số điện thoại",
  "contacts.actions.noEmail": "Không có địa chỉ email",
  "deals.title": "Giao dịch",
  "deals.subtitle": "Quản lý các giao dịch đang hoạt động và đã hoàn thành.",
  "deals.tabs.all": "Tất cả giao dịch",
  "deals.tabs.my": "Giao dịch của tôi",
  "deals.create": "Tạo giao dịch",
  "deals.empty.title": "Chưa có giao dịch nào",
  "deals.empty.desc": "Tạo giao dịch đầu tiên để bắt đầu.",
  "deals.search": "Tìm kiếm giao dịch...",
  "deals.validation.titleRequired": "Tiêu đề giao dịch là bắt buộc",
  "deals.validation.titleLength": "Tiêu đề không được vượt quá 100 ký tự",
  "deals.validation.clientRequired": "Vui lòng chọn ít nhất một khách hàng",
  "deals.validation.notesLength": "Ghi chú không được vượt quá 200 ký tự",
  "deals.filter.all": "Tất cả giao dịch",
  "deals.filter.active": "Hoạt động",
  "deals.filter.pending": "Đang chờ",
  "deals.filter.closed": "Đã đóng",
  "deals.column.draft": "Bản thảo",
  "deals.column.active": "Hoạt động",
  "deals.column.pending": "Đang chờ",
  "deals.column.pending_documents": "Chờ tài liệu",
  "deals.column.pending_signature": "Chờ ký tên",
  "deals.column.pending_payment": "Chờ thanh toán",
  "deals.column.escrow_funded": "Đã ký quỹ",
  "deals.column.release_requested": "Yêu cầu giải ngân",
  "deals.column.disputed": "Tranh chấp",
  "deals.column.on_hold": "Tạm dừng",
  "deals.column.completed": "Hoàn thành",
  "deals.column.cancelled": "Đã hủy",
  "deals.column.closed": "Đã đóng",
  "deals.card.documents": "{count} tài liệu",
  "deals.card.messages": "{count} tin nhắn",
  "deals.dialog.title": "Tạo giao dịch mới",
  "deals.dialog.dealTitle": "Tiêu đề giao dịch",
  "deals.dialog.dealTitlePlaceholder": "ví dụ: Mua xe - Honda Civic 2023",
  "deals.dialog.client": "Khách hàng",
  "deals.dialog.office": "Văn phòng ảo",
  "deals.dialog.type": "Loại giao dịch",
  "deals.dialog.notes": "Ghi chú",
  "deals.dialog.notesPlaceholder": "Thêm ghi chú về giao dịch này...",
  "deals.dialog.creating": "Đang tạo...",
  "deals.dialog.create": "Tạo giao dịch",
  "dealRoom.back": "Quay lại giao dịch",
  "dealRoom.readOnly.title": "Chỉ đọc",
  "dealRoom.readOnly.closedMessage": "Giao dịch này đã được đóng. Phòng giao dịch hiện ở chế độ chỉ đọc để tham khảo và kiểm toán.",
  "dealRoom.readOnly.cancelledMessage": "Giao dịch này đã bị hủy. Phòng giao dịch hiện ở chế độ chỉ đọc để tham khảo và kiểm toán.",
  "dealRoom.readOnly.completedMessage": "Giao dịch này đã hoàn thành thành công. Phòng giao dịch hiện ở chế độ chỉ đọc để tham khảo và kiểm toán.",
  "dealRoom.tabs.messages": "Tin nhắn",
  "dealRoom.tabs.documents": "Tài liệu",
  "dealRoom.tabs.contract": "Hợp đồng",
  "dealRoom.timeline.title": "Dòng thời gian hoạt động",
  "dealRoom.timeline.empty": "Chưa có hoạt động nào được ghi nhận.",
  "dealRoom.timeline.createdBy": "bởi {name}",
  "dealRoom.details.title": "Chi tiết giao dịch",
  "dealRoom.details.clients": "Khách hàng",
  "dealRoom.details.notes": "Ghi chú",
  "dealRoom.details.type": "Loại",
  "dealRoom.details.documents": "Tài liệu",
  "dealRoom.details.messages": "Tin nhắn",
  "dealRoom.aiSummary.title": "Tóm tắt AI",
  "dealRoom.aiSummary.generating": "Đang tạo tóm tắt...",
  "dealRoom.messages.empty": "Chưa có tin nhắn nào. Bắt đầu cuộc trò chuyện.",
  "dealRoom.messages.placeholder": "Nhập tin nhắn...",
  "dealRoom.messages.send": "Gửi",
  "dealRoom.messages.sending": "Đang gửi...",
  "dealRoom.messages.showOriginal": "Hiển thị bản gốc",
  "dealRoom.messages.showTranslation": "Hiển thị bản dịch",
  "dealRoom.messages.translatedFrom": "Dịch từ {language}",
  "dealRoom.messages.suggestReply": "Đề xuất phản hồi",
  "dealRoom.documents.empty": "Chưa có tài liệu nào được tải lên.",
  "dealRoom.documents.upload": "Tải lên tài liệu",
  "dealRoom.documents.uploading": "Đang tải lên...",
  "dealRoom.documents.analyze": "Phân tích",
  "dealRoom.documents.analyzing": "Đang phân tích...",
  "dealRoom.documents.download": "Tải xuống",
  "dealRoom.documents.delete": "Xóa",
  "dealRoom.documents.pending": "Chờ phân tích",
  "dealRoom.documents.analyzed": "Đã phân tích",
  "dealRoom.documents.aiAnalysis": "Phân tích tài liệu AI",
  "dealRoom.documents.type": "Loại tài liệu",
  "dealRoom.documents.confidence": "Độ tin cậy",
  "dealRoom.documents.summary": "Tóm tắt",
  "dealRoom.documents.issues": "Vấn đề",
  "dealRoom.contract.empty.title": "Chưa tạo hợp đồng",
  "dealRoom.contract.empty.desc": "Tạo bản thảo hợp đồng AI cho giao dịch này.",
  "dealRoom.contract.generate": "Tạo bản thảo hợp đồng",
  "dealRoom.contract.regenerate": "Tạo lại hợp đồng",
  "dealRoom.contract.generating": "Đang tạo...",
  "dealRoom.contract.aiLabel": "Bản thảo hợp đồng do AI tạo",
  "dealRoom.contract.language": "Ngôn ngữ",
  "dealRoom.contract.copy": "Sao chép",
  "dealRoom.contract.copied": "Đã sao chép vào clipboard",
  "dealRoom.contract.type": "Loại hợp đồng",
  "dealRoom.contract.generated": "Đã tạo",
  "dealRoom.contract.languages": "Ngôn ngữ",
  "dealRoom.contract.status": "Trạng thái",
  "dealRoom.contract.notice": "Phân tích tài liệu AI: Một hoặc nhiều điều khoản không có từ tương đương trực tiếp giữa các ngôn ngữ bạn đã chọn. Chúng tôi đã sử dụng ngôn ngữ mô tả thay thế. Vui lòng xem xét kỹ các phần này và xác nhận với bên kia nếu cần.",
  "dealRoom.contract.analysisWarning": "Một số tài liệu chưa được phân tích. Phân tích AI giúp cải thiện độ chính xác của hợp đồng.",
  "dealRoom.contract.dialog.title": "Tạo bản thảo hợp đồng",
  "dealRoom.contract.dialog.desc": "AI sẽ tạo hợp đồng song ngữ dựa trên chi tiết giao dịch.",
  "dealRoom.contract.dialog.disclaimer": "Đây là bản thảo do AI tạo để xem xét. Hãy nhờ chuyên gia pháp lý xem xét trước khi ký kết.",
  "dealRoom.contract.dialog.type": "Loại hợp đồng",
  "dealRoom.contract.dialog.languages": "Ngôn ngữ",
  "dealRoom.contract.dialog.languagesHelp": "Chọn hai ngôn ngữ cho hợp đồng song ngữ của bạn. Tất cả ngôn ngữ Tier 1 đều được hỗ trợ đầy đủ.",
  "dealRoom.contract.dialog.primary": "Chính",
  "dealRoom.contract.dialog.secondary": "Phụ",
  "dealRoom.contract.dialog.terms": "Điều khoản đặc biệt",
  "dealRoom.contract.dialog.termsPlaceholder": "Thêm bất kỳ điều khoản hoặc điều kiện đặc biệt nào...",
  "dealRoom.contract.dialog.generate": "Tạo hợp đồng",
  "dealRoom.contract.dialog.generating": "Đang tạo...",
  "dealRoom.status.change": "Thay đổi trạng thái",
  "dealRoom.status.dialog.title": "Thay đổi trạng thái giao dịch",
  "dealRoom.status.dialog.from": "Từ",
  "dealRoom.status.dialog.to": "Đến",
  "dealRoom.status.dialog.reason": "Lý do (tùy chọn)",
  "dealRoom.status.dialog.reasonPlaceholder": "Tại sao bạn thay đổi trạng thái?",
  "dealRoom.status.dialog.confirm": "Xác nhận thay đổi",
  "dealRoom.status.dialog.changing": "Đang thay đổi...",
  "dealRoom.status.toast.changed": "Trạng thái đã thay đổi thành {status}",
  "dealRoom.upgrade.title": "Nâng cấp lên Business",
  "dealRoom.upgrade.desc": "Tạo hợp đồng yêu cầu gói Business.",
  "dealRoom.upgrade.features": "Với Business, bạn có:",
  "dealRoom.upgrade.feature1": "Bản thảo hợp đồng do AI tạo",
  "dealRoom.upgrade.feature2": "Phân tích tài liệu nâng cao",
  "dealRoom.upgrade.feature3": "Hỗ trợ ưu tiên",
  "dealRoom.upgrade.button": "Nâng cấp ngay",
  "settings.title": "Cài đặt",
  "settings.subtitle": "Quản lý tài khoản và tổ chức của bạn",
  "settings.tabs.profile": "Hồ sơ",
  "settings.tabs.organization": "Tổ chức",
  "settings.tabs.sharing": "Chia sẻ QR",
  "settings.profile.title": "Cài đặt hồ sơ",
  "settings.profile.subtitle": "Quản lý thông tin cá nhân",
  "settings.profile.name": "Họ và tên",
  "settings.profile.email": "Email",
  "settings.profile.emailNote": "Không thể thay đổi email",
  "settings.profile.accountType": "Loại tài khoản",
  "settings.profile.accountTypeHelp": "Chọn loại mô tả bạn tốt nhất",
  "settings.profile.language": "Ngôn ngữ ưa thích",
  "settings.profile.languageHelp": "Tất cả giao diện, tin nhắn và hợp đồng sẽ được hiển thị bằng ngôn ngữ này.",
  "settings.profile.save": "Lưu thay đổi",
  "settings.profile.saving": "Đang lưu...",
  "settings.profile.saved": "Hồ sơ đã cập nhật",
  "settings.org.title": "Cài đặt tổ chức",
  "settings.org.subtitle": "Quản lý thông tin doanh nghiệp",
  "settings.org.name": "Tên tổ chức",
  "settings.org.type": "Loại ngành",
  "settings.org.billingEmail": "Email thanh toán",
  "settings.org.plan": "Gói",
  "settings.org.verification": "Trạng thái xác minh",
  "settings.org.save": "Lưu thay đổi",
  "settings.org.saving": "Đang lưu...",
  "settings.org.saved": "Tổ chức đã cập nhật",
  "settings.org.noOrg": "Không tìm thấy tổ chức",
  "qr.title": "Chia sẻ mã QR PocketFiler của bạn",
  "qr.description": "Hiển thị mã này cho khách hàng hoặc đối tác. Khi họ quét mã, họ có thể kết nối với bạn và bắt đầu giao dịch trong vài giây.",
  "qr.generate": "Tạo mã QR",
  "qr.regenerated": "Mã QR đã được tạo lại. Các liên kết cũ hiện không còn hợp lệ.",
  "qr.linkCopied": "Liên kết đã sao chép vào clipboard",
  "qr.copyLink": "Sao chép liên kết",
  "qr.copied": "Đã sao chép!",
  "qr.share": "Chia sẻ",
  "qr.download": "Tải xuống",
  "qr.regenerate": "Đặt lại",
  "qr.yourLink": "Liên kết kết nối của bạn:",
  "qr.clickToExpand": "Nhấp để xem toàn màn hình",
  "qr.scanToConnect": "Quét để kết nối",
  "qr.scanInstructions": "Quét mã QR này bằng PocketFiler hoặc bất kỳ trình quét QR nào để kết nối.",
  "qr.primaryLanguage": "Ngôn ngữ chính",
  "support.title": "Hỗ trợ AI",
  "support.subtitle": "Hỏi bất cứ điều gì về PocketFiler",
  "support.askAI": "Hỏi AI",
  "support.openChat": "Mở hỗ trợ AI",
  "support.welcome": "Xin chào! Tôi là trợ lý AI của PocketFiler. Tôi có thể giúp bạn:\n\n- Tạo và quản lý giao dịch\n- Gửi tài liệu để ký\n- Sử dụng tính năng kết nối QR\n- Mời khách hàng\n- Bất kỳ câu hỏi nào khác về PocketFiler\n\nTôi có thể giúp gì cho bạn hôm nay?",
  "support.inputPlaceholder": "Nhập câu hỏi của bạn...",
  "support.clearChat": "Xóa cuộc trò chuyện",
  "support.error": "Không thể gửi tin nhắn. Vui lòng thử lại.",
  "support.scheduleCall": "Đặt lịch gọi với bộ phận hỗ trợ",
  "support.scheduleTitle": "Đặt lịch cuộc gọi hỗ trợ",
  "support.yourTimezone": "Múi giờ của bạn",
  "support.availableTimes": "Thời gian có sẵn",
  "support.inYourTime": "theo giờ địa phương của bạn",
  "support.slotsError": "Không thể tải thời gian có sẵn.",
  "support.booked": "Cuộc gọi đã được đặt lịch thành công!",
  "support.bookingError": "Không thể đặt lịch. Vui lòng thử lại.",
  "support.bookingConfirmed": "Tuyệt vời, tôi đã đặt lịch cuộc gọi của bạn lúc {time}. Bạn sẽ nhận được xác nhận với liên kết cuộc gọi. Còn gì tôi có thể giúp không?",
  "livekit.joinCall": "Tham gia cuộc gọi",
  "livekit.call": "Cuộc gọi",
  "livekit.inCall": "Đang gọi",
  "livekit.leaveCall": "Rời cuộc gọi",
  "livekit.participant": "người tham gia",
  "livekit.participants": "người tham gia",
  "livekit.connecting": "Đang kết nối...",
  "livekit.error.connect": "Không thể kết nối cuộc gọi. Vui lòng thử lại.",
  "livekit.error.connection": "Lỗi kết nối. Vui lòng kiểm tra mạng và thử lại.",
  "livekit.error.permission": "Bạn không có quyền tham gia cuộc gọi này.",
  "livekit.hint": "Nói chuyện trong giao dịch này thay vì chuyển ứng dụng.",
  "captions.on": "Phụ đề bật",
  "captions.off": "Phụ đề tắt",
  "captions.enable": "Bật phụ đề",
  "captions.disable": "Tắt phụ đề",
  "captions.language": "Ngôn ngữ phụ đề",
  "captions.live": "Trực tiếp",
  "captions.connecting": "Đang kết nối...",
  "captions.error.toggle": "Không thể bật/tắt phụ đề",
  "captions.error.connect": "Không thể kết nối dịch vụ phụ đề",
  "captions.translating": "Đang dịch...",
  "captions.original": "Bản gốc",
  "captions.translated": "Đã dịch",
  "recording.start": "Ghi âm",
  "recording.stop": "Dừng",
  "recording.started": "Đã bắt đầu ghi âm",
  "recording.stopped": "Đã dừng ghi âm. Đang xử lý...",
  "recording.processing": "Đang xử lý...",
  "recording.completed": "Ghi âm hoàn thành",
  "recording.failed": "Ghi âm thất bại",
  "recording.play": "Phát",
  "recording.download": "Tải xuống",
  "recording.delete": "Xóa",
  "recording.confirmDelete": "Xóa bản ghi âm này?",
  "recording.deleted": "Đã xóa bản ghi âm",
  "recording.noRecordings": "Chưa có bản ghi âm nào",
  "recording.playback": "Phát lại bản ghi âm",
  "recording.viewRecordings": "Xem bản ghi âm",
  "recording.error.start": "Không thể bắt đầu ghi âm",
  "recording.error.stop": "Không thể dừng ghi âm",
  "recording.error.delete": "Không thể xóa bản ghi âm",
  "recording.error.noCall": "Không có cuộc gọi đang hoạt động. Vui lòng tham gia cuộc gọi trước.",
  "schedule.button": "Lên lịch",
  "schedule.title": "Lên lịch cuộc gọi hoặc ghi âm",
  "schedule.description": "Chọn ngày và giờ. Quý khách có thể tham gia cuộc gọi khi đến giờ.",
  "schedule.type": "Loại",
  "schedule.typeCall": "Cuộc gọi",
  "schedule.typeRecording": "Ghi âm",
  "schedule.dateTime": "Ngày & giờ",
  "schedule.create": "Lên lịch",
  "schedule.created": "Đã lên lịch",
  "schedule.upcoming": "Lịch sắp tới",
  "schedule.cancel": "Hủy",
  "schedule.chooseDateTime": "Vui lòng chọn ngày và giờ",
  "connect.typePerson": "Cá nhân",
  "connect.typeOrg": "Tổ chức",
  "connect.titleAuth": "Quý khách đang kết nối với",
  "connect.titleUnauth": "Kết nối với",
  "connect.infoUnauth": "Người này sử dụng PocketFiler để quản lý các giao dịch và tài liệu đa ngôn ngữ một cách bảo mật.",
  "connect.startDeal": "Bắt đầu giao dịch",
  "connect.joinOffice": "Tham gia văn phòng ảo",
  "connect.loggedInAs": "Đã đăng nhập với tên",
  "connect.createAccount": "Tạo tài khoản miễn phí",
  "connect.login": "Đăng nhập",
  "connect.dealCreated": "Tạo giao dịch thành công",
  "connect.error.invalid": "Liên kết kết nối không hợp lệ",
  "connect.error.invalidDesc": "Liên kết kết nối này không hợp lệ hoặc đã hết hạn.",
  "connect.error.server": "Đã xảy ra lỗi",
  "connect.error.serverDesc": "Vui lòng thử lại sau.",
  "common.backToHome": "Trở về trang chủ",
  "invite.language.title": "Chọn ngôn ngữ của quý khách",
  "invite.language.subtitle": "Chúng tôi sẽ hiển thị tất cả hướng dẫn bằng ngôn ngữ của quý khách.",
  "invite.welcome.title": "Chào mừng đến với",
  "invite.welcome.subtitle": "Chúng tôi đã sẵn sàng tiếp nhận tài liệu của quý khách.",
  "invite.welcome.time": "5-10 phút",
  "invite.welcome.timeLabel": "Thời gian ước tính",
  "invite.welcome.secure": "Bảo mật và miễn phí",
  "invite.welcome.secureDesc": "Tài liệu của quý khách được mã hóa. Dịch vụ này miễn phí cho quý khách.",
  "invite.welcome.start": "Bắt đầu tải lên",
  "invite.documents.needed": "Tài liệu cần thiết",
  "invite.upload.title": "Tải lên tài liệu",
  "invite.upload.dragDrop": "Kéo thả tệp vào đây, hoặc nhấp để chọn",
  "invite.upload.or": "hoặc",
  "invite.upload.takePhoto": "Hình ảnh",
  "invite.upload.browse": "Tệp",
  "invite.upload.uploading": "Đang tải lên...",
  "invite.upload.analyzing": "Đang kiểm tra tài liệu...",
  "invite.upload.success": "Tải lên thành công",
  "invite.upload.next": "Tài liệu tiếp theo",
  "invite.upload.finish": "Xem lại tất cả",
  "invite.upload.skip": "Bỏ qua",
  "invite.upload.progress": "Tiến trình",
  "invite.complete.title": "Hoàn thành!",
  "invite.complete.subtitle": "Tài liệu của quý khách đã được gửi thành công.",
  "invite.complete.message": "Chúng tôi đã nhận được tất cả tài liệu của quý khách. Quý khách sẽ được liên hệ sớm.",
  "invite.complete.summary": "Tài liệu đã gửi",
  "invite.complete.securityNote": "Tài liệu của quý khách được lưu trữ an toàn và chỉ được truy cập bởi nhân viên có thẩm quyền.",
  "invite.chat.title": "Trò chuyện với đại diện",
  "invite.chat.placeholder": "Nhập tin nhắn...",
  "invite.chat.empty": "Chưa có tin nhắn nào. Bắt đầu cuộc trò chuyện.",
  "invite.chat.sent": "Tin nhắn của quý khách đã được gửi.",
  "invite.chat.willRespond": "Chúng tôi sẽ phản hồi sớm nhất có thể.",
  "invite.chat.sending": "Đang gửi...",
  "invite.error.title": "Liên kết không hợp lệ hoặc đã hết hạn",
  "invite.error.message": "Liên kết mời này không còn hợp lệ. Vui lòng liên hệ người gửi để nhận liên kết mới.",
  "common.loading": "Đang tải...",
  "common.save": "Lưu",
  "common.cancel": "Hủy",
  "common.delete": "Xóa",
  "common.edit": "Chỉnh sửa",
  "common.create": "Tạo",
  "common.close": "Đóng",
  "common.dismiss": "Bỏ qua",
  "common.confirm": "Xác nhận",
  "common.back": "Trở lại",
  "common.next": "Tiếp theo",
  "common.previous": "Trước",
  "common.of": "của",
  "common.search": "Tìm kiếm",
  "common.filter": "Lọc",
  "common.sort": "Sắp xếp",
  "common.viewAll": "Xem tất cả",
  "common.refresh": "Làm mới",
  "common.retry": "Thử lại",
  "common.noResults": "Không tìm thấy kết quả",
  "common.yes": "Có",
  "common.no": "Không",
  "common.or": "hoặc",
  "common.and": "và",
  "common.optional": "tùy chọn",
  "common.required": "bắt buộc",
  "status.draft": "Bản nháp",
  "status.active": "Đang hoạt động",
  "status.pending": "Đang chờ",
  "status.pending_documents": "Chờ tài liệu",
  "status.pending_signature": "Chờ ký",
  "status.on_hold": "Tạm dừng",
  "status.closed": "Đã đóng",
  "status.cancelled": "Đã hủy",
  "pwa.installApp": "Cài đặt ứng dụng",
  "pwa.iosHint": "Nhấn biểu tượng Chia sẻ và \"Thêm vào Màn hình chính\" để cài đặt PocketFiler.",
  "pwa.installed": "Ứng dụng đã được cài đặt thành công!",
  "pwa.banner.title": "Tải ứng dụng PocketFiler",
  "pwa.banner.subtitle": "Truy cập nhanh hơn, hoạt động ngoại tuyến",
  "pwa.banner.install": "Cài đặt",
  "pwa.ios.title": "Cài đặt PocketFiler",
  "pwa.ios.description": "Thêm PocketFiler vào màn hình chính để có trải nghiệm tốt nhất:",
  "pwa.ios.step1": "Nhấn",
  "pwa.ios.shareButton": "nút Chia sẻ",
  "pwa.ios.inToolbar": "trên thanh công cụ trình duyệt",
  "pwa.ios.step2": "Cuộn xuống và nhấn",
  "pwa.ios.step3": "Nhấn",
  "pwa.ios.inTopRight": "ở góc trên bên phải",
  "pwa.ios.gotIt": "Đã hiểu",
  "pwa.opera.title": "Không có sẵn trong Opera",
  "pwa.opera.desktopNotSupported": "Opera desktop không hỗ trợ cài đặt PWA. Để cài đặt PocketFiler như một ứng dụng, vui lòng mở trong Google Chrome hoặc Microsoft Edge.",
  "pwa.opera.recommendedBrowsers": "Sử dụng thay thế:",
  "pwa.opera.chromeHint": "mở trang này, sau đó nhấp vào biểu tượng cài đặt trong thanh địa chỉ",
  "pwa.opera.edgeHint": "mở trang này, sau đó nhấp vào biểu tượng cài đặt (⊕) trong thanh địa chỉ",
  "pwa.opera.mobileTitle": "Cài đặt PocketFiler trong Opera",
  "pwa.opera.mobileDescription": "Nhấn biểu tượng + ở cuối Opera, hoặc sử dụng menu bên dưới:",
  "pwa.opera.mobileStep1": "Nhấn",
  "pwa.opera.mobileStep1b": "biểu tượng cộng (+) trong thanh dưới của Opera",
  "pwa.opera.mobileStep2": "Hoặc nhấn",
  "pwa.opera.mobileAddPage": "Thêm trang vào",
  "pwa.opera.mobileHomeScreen": "Màn hình chính",
  "pwa.firefox.hint": "Trong Firefox, tìm biểu tượng cài đặt (⊕) trong thanh địa chỉ để thêm ứng dụng này vào máy tính của bạn.",
  "error.generic": "Đã xảy ra lỗi. Vui lòng thử lại.",
  "error.network": "Lỗi mạng. Vui lòng kiểm tra kết nối.",
  "error.unauthorized": "Quý khách không có quyền thực hiện hành động này.",
  "error.notFound": "Không tìm thấy tài nguyên được yêu cầu.",
  "error.validation": "Vui lòng kiểm tra thông tin nhập và thử lại.",
  "error.serverError": "Lỗi máy chủ. Vui lòng thử lại sau.",
  "success.saved": "Đã lưu thay đổi thành công.",
  "success.created": "Đã tạo thành công.",
  "success.deleted": "Đã xóa thành công.",
  "success.sent": "Đã gửi thành công.",
  "success.uploaded": "Đã tải lên thành công.",
  "time.justNow": "Vừa xong",
  "time.minutesAgo": "{count} phút trước",
  "time.hoursAgo": "{count} giờ trước",
  "time.daysAgo": "{count} ngày trước",
  "time.today": "Hôm nay",
  "time.yesterday": "Hôm qua",
  "dealRoom.notFound": "Không tìm thấy giao dịch",
  "dealRoom.loading": "Đang tải giao dịch...",
  "dealRoom.conversation.title": "Cuộc trò chuyện giao dịch",
  "dealRoom.conversation.you": "Bạn",
  "dealRoom.conversation.client": "Khách hàng",
  "dealRoom.conversation.colleague": "Đồng nghiệp",
  "dealRoom.messages.hideOriginal": "Ẩn tin nhắn gốc",
  "dealRoom.messages.original": "Gốc ({language})",
  "dealRoom.messages.disabled": "Tính năng nhắn tin đã bị vô hiệu hóa cho trạng thái giao dịch này",
  "dealRoom.messages.connecting": "Đang kết nối tới cuộc trò chuyện...",
  "dealRoom.messages.connectionError": "Không thể kết nối tới cuộc trò chuyện.",
  "dealRoom.messages.aiSuggest": "Câu trả lời được AI gợi ý",
  "messages.readAloud.title": "Đọc to",
  "messages.readAloud.error": "Đọc to thất bại",
  "dealRoom.documents.title": "Tài liệu",
  "dealRoom.documents.uploadDisabled": "Tải lên bị vô hiệu hóa",
  "dealRoom.documents.pendingAnalysis": "Đang chờ phân tích",
  "dealRoom.documents.uploadFirst": "Tải lên tài liệu đầu tiên",
  "dealRoom.documents.uploadHelp": "Tải lên tài liệu cho giao dịch này để AI phân tích",
  "dealRoom.documents.uploadDisabledHelp": "Tải lên tài liệu đã bị vô hiệu hóa cho trạng thái giao dịch này",
  "dealRoom.documents.analyzeWithAI": "Phân tích bằng AI",
  "dealRoom.documents.notAnalyzed": "Chưa được phân tích",
  "dealRoom.documents.notAnalyzedHelp": "Chạy phân tích AI để trích xuất loại tài liệu, các trường và nhận thông tin chi tiết",
  "dealRoom.documents.analyzeDocument": "Phân tích tài liệu",
  "dealRoom.documents.extractedFields": "Các trường đã trích xuất",
  "dealRoom.documents.issuesDetected": "Các vấn đề đã phát hiện",
  "dealRoom.documents.preview": "Xem trước",
  "dealRoom.documents.previewNotAvailable": "Không có bản xem trước. Đang tải xuống...",
  "dealRoom.documents.uploaded": "Đã tải lên",
  "dealRoom.documents.deleteConfirm": "Bạn có chắc chắn muốn xóa tài liệu này không?",
  "documents.readAloud.title": "Đọc to",
  "documents.readAloud.analyzeFirst": "Vui lòng phân tích tài liệu này trước để đọc to.",
  "documents.readAloud.error": "Đọc to thất bại",
  "dealRoom.onHold.message": "Giao dịch này đang tạm dừng. Tải lên tài liệu đã bị vô hiệu hóa. Bạn vẫn có thể gửi tin nhắn để phối hợp.",
  "dealRoom.pendingSignature.loading": "Đang tải trạng thái chữ ký...",
  "dealRoom.pendingSignature.message": "Hợp đồng đã sẵn sàng để ký. Tải lên tài liệu bị vô hiệu hóa cho đến khi hợp đồng được ký hoặc hoàn nguyên.",
  "dealRoom.pendingSignature.signedWaitingOthers": "Đã ký thành công. Đang chờ các bên tham gia khác.",
  "dealRoom.signedByAll.message": "Đã được ký bởi tất cả bên tham gia. Tiến hành thanh toán.",
  "dealRoom.signedByAll.addPayment": "Thêm thanh toán",
  "dealRoom.signature.signed": "Đã ký",
  "dealRoom.signature.signedByYou": "Đã ký bởi bạn",
  "dealRoom.signature.success": "Ký hợp đồng thành công!",
  "dealRoom.signaturesList.title": "Chữ ký",
  "dealRoom.signaturesList.dealOwner": "Chủ giao dịch",
  "dealRoom.signaturesList.clients": "Khách hàng",
  "dealRoom.signaturesList.pending": "Đang chờ",
  "dealRoom.signaturesList.signedOn": "Đã ký vào",
  "dealRoom.signaturesList.viewSignatures": "Xem chữ ký",
  "dealRoom.status.current": "hiện tại",
  "dealRoom.status.finalWarning": "Đây là trạng thái cuối cùng. Giao dịch không thể mở lại sau hành động này.",
  "dealRoom.contract.purchaseAgreement": "Thỏa thuận mua bán",
  "dealRoom.contract.purchaseAgreementDesc": "Hợp đồng thỏa thuận mua bán tiêu chuẩn",
  "dealRoom.contract.noContract": "Chưa có hợp đồng",
  "dealRoom.contract.noContractDesc": "Tạo bản dự thảo hợp đồng được hỗ trợ bởi AI dựa trên chi tiết giao dịch và tài liệu của bạn.",
  "dealRoom.contract.notAvailable": "Tạo hợp đồng không khả dụng cho giao dịch có trạng thái {status}.",
  "dealRoom.contract.locked": "Tạo hợp đồng bị khóa khi đang chờ chữ ký.",
  "dealRoom.contract.requiresPlan": "Yêu cầu gói Business Starter",
  "dealRoom.toast.dealUpdated": "Đã cập nhật giao dịch",
  "dealRoom.toast.statusChanged": "Trạng thái giao dịch đã thay đổi thành {status}",
  "dealRoom.toast.statusFailed": "Thay đổi trạng thái thất bại",
  "dealRoom.toast.contractGenerated": "Đã tạo bản dự thảo hợp đồng thành công",
  "dealRoom.toast.contractCopied": "Hợp đồng {language} đã sao chép vào clipboard",
  "dealRoom.toast.messageFailed": "Gửi tin nhắn thất bại",
  "dealRoom.toast.suggestionFailed": "Tạo gợi ý thất bại",
  "dealRoom.toast.documentUploaded": "Đã tải lên tài liệu",
  "dealRoom.toast.uploadFailed": "Tải lên thất bại",
  "dealRoom.toast.analysisComplete": "Phân tích tài liệu AI hoàn thành",
  "dealRoom.toast.analysisFailed": "Phân tích AI thất bại",
  "dealRoom.toast.documentDeleted": "Đã xóa tài liệu",
  "dealRoom.toast.deleteFailed": "Xóa tài liệu thất bại",
  "dealRoom.incomingCall.started": "{name} đã bắt đầu cuộc gọi",
  "dealRoom.incomingCall.inProgress": "Cuộc gọi đang diễn ra",
  "dealRoom.incomingCall.accept": "Chấp nhận",
  "dealRoom.incomingCall.decline": "Từ chối",
  "dealRoom.details.created": "Đã tạo",
  "dealRoom.details.addNotes": "Thêm ghi chú giao dịch...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Bỏ qua lúc này",
  "onboarding.badge": "Thiết lập được hỗ trợ bởi AI",
  "onboarding.welcome": "Chào mừng, {name}!",
  "onboarding.welcomeGeneric": "Chào mừng!",
  "onboarding.subtitle": "Hãy thiết lập không gian làm việc PocketFiler của bạn. Hãy nói với AI Concierge về doanh nghiệp của bạn, và chúng tôi sẽ cấu hình mọi thứ cho bạn.",
  "onboarding.step1": "Mô tả doanh nghiệp và nhu cầu của bạn",
  "onboarding.step2": "AI đề xuất thiết lập của bạn",
  "onboarding.step3": "Bắt đầu quản lý giao dịch",
  "onboarding.concierge.title": "AI Concierge",
  "onboarding.toast.officeCreated": "Đã tạo văn phòng ảo!",
  "validation.nameRequired": "Tên là bắt buộc",
  "validation.nameTooLong": "Tên phải ít hơn 50 ký tự",
  "validation.emailRequired": "Email là bắt buộc",
  "validation.emailInvalid": "Định dạng email không hợp lệ",
  "validation.phoneRequired": "Số điện thoại là bắt buộc",
  "validation.phoneInvalid": "Số điện thoại không hợp lệ (10-15 chữ số)",
  "validation.noteTooLong": "Ghi chú phải ít hơn 200 ký tự",
  "common.deleteConfirmTitle": "Bạn có chắc chắn không?",
  "common.deleteConfirmDesc": "Hành động này không thể hoàn tác. Điều này sẽ xóa vĩnh viễn mục này và loại bỏ dữ liệu khỏi máy chủ của chúng tôi.",
  "dashboard.actions.addClient": "Thêm khách hàng",
  "dashboard.actions.all": "Tất cả",
  "dashboard.actions.createContract": "Tạo hợp đồng",
  "dashboard.actions.createInvoice": "Tạo hóa đơn",
  "dashboard.actions.customize": "Tùy chỉnh",
  "dashboard.actions.newDeal": "Giao dịch mới",
  "dashboard.actions.scheduleMeeting": "Lên lịch cuộc họp",
  "dashboard.actions.uploadDocument": "Tải lên tài liệu",
  "dashboard.actions.viewAll": "Xem tất cả",
  "dashboard.briefing.default": "Hiện tại không có gì khẩn cấp. Không gian làm việc của bạn đang ở trạng thái tốt.",
  "dashboard.briefing.title": "Báo cáo hàng ngày",
  "dashboard.empty.activity": "Không có hoạt động gần đây.",
  "dashboard.empty.deals": "Chưa có giao dịch nào. Tạo giao dịch đầu tiên để xem quy trình.",
  "dashboard.empty.documents": "Tất cả tài liệu đã được cập nhật.",
  "dashboard.empty.meetings": "Không có cuộc họp sắp tới.",
  "dashboard.empty.tasks": "Không có nhiệm vụ nào đang mở.",
  "dashboard.greeting.afternoon": "Chào buổi chiều",
  "dashboard.greeting.evening": "Chào buổi tối",
  "dashboard.greeting.morning": "Chào buổi sáng",
  "dashboard.greeting.subtitle": "Đây là những gì đang diễn ra trong không gian làm việc của bạn.",
  "dashboard.stats.documents": "Tài liệu",
  "dashboard.stats.invoicesDue": "Hóa đơn đến hạn",
  "dashboard.stats.meetingsComing": "Cuộc họp sắp tới",
  "dashboard.stats.tasksDue": "Nhiệm vụ đến hạn",
  "dashboard.stats.unreadMessages": "Tin nhắn chưa đọc",
  "dashboard.widgets.dealPipeline": "Quy trình giao dịch",
  "dashboard.widgets.documentsAttention": "Tài liệu cần chú ý",
  "dashboard.widgets.gettingStarted": "Bắt đầu",
  "dashboard.widgets.quickActions": "Hành động nhanh",
  "dashboard.widgets.recentActivity": "Hoạt động gần đây",
  "dashboard.widgets.tasks": "Nhiệm vụ",
  "dashboard.widgets.upcomingMeetings": "Cuộc họp sắp tới",
  "dashboard.steps.createDeal": "Tạo giao dịch đầu tiên",
  "dashboard.steps.addClient": "Thêm khách hàng",
  "dashboard.steps.uploadDocument": "Tải lên tài liệu",
  "dashboard.steps.scheduleMeeting": "Lên lịch cuộc họp",
  "dashboard.steps.createInvoice": "Tạo hóa đơn",
  "dashboard.steps.addLogo": "Thêm logo",
  "dashboard.steps.complete": "hoàn thành",
  "dashboard.time.overdue": "Quá hạn",
  "dashboard.time.today": "Hôm nay",
  "dashboard.time.tomorrow": "Ngày mai",
  "dashboard.time.noDate": "Không có ngày",
  "dashboard.docReason.sent": "Đã gửi, đang chờ phản hồi",
  "dashboard.docReason.notAnalyzed": "Chưa được phân tích",
  "dashboard.docReason.draft": "Bản dự thảo, chưa hoàn thiện",
  "dashboard.docReason.needsReview": "Cần xem xét",
  "docViewer.notFound": "Không tìm thấy tài liệu",
  "docViewer.previewUnavailable": "Không có bản xem trước cho loại tập tin này",
  "docViewer.aiAnalysis": "Phân tích AI",
  "docViewer.documentType": "Loại tài liệu",
  "docViewer.summary": "Tóm tắt",
  "docViewer.extractedFields": "Trường được trích xuất",
  "docViewer.issues": "Vấn đề",
  "docViewer.tags": "Thẻ",
  "docViewer.noPreviousVersions": "Không có phiên bản trước đó",
  "docViewer.noActivity": "Chưa có hoạt động nào",
  "auth.forgotPassword.title": "Đặt lại mật khẩu của bạn",
  "guestSign.loading": "Đang tải hợp đồng...",
  "guestSign.unableToLoad": "Không thể tải hợp đồng",
  "guestSign.signed": "Hợp đồng đã được ký",
  "guestSign.createOwn": "Bạn có muốn tạo và quản lý hợp đồng riêng của mình không?",
  "guestSign.secureSign": "Ký an toàn",
  "meeting.ended": "Cuộc họp này đã kết thúc",
  "meeting.cancelled": "Cuộc họp đã bị hủy",
  "meeting.notFound": "Không tìm thấy cuộc họp",
  "meeting.joiningAs": "Tham gia với tư cách",
  "meeting.yourName": "Tên của bạn *",
  "meeting.emailOptional": "Email (tùy chọn)",
  "notFound.title": "Không tìm thấy trang",
  "notFound.dashboard": "Đi đến Dashboard",
  "notFound.home": "Trang chủ",
  "auth.resetPassword.invalidLink": "Liên kết không hợp lệ",
  "auth.resetPassword.title": "Đặt mật khẩu mới",
  "templates.category": "Danh mục",
  "templates.legal": "Pháp lý",
  "templates.sales": "Bán hàng",
  "templates.services": "Dịch vụ",
  "templates.finance": "Tài chính",
  "templates.library": "Thư viện mẫu",
  "templates.libraryDesc": "Các mẫu tài liệu sẵn sàng sử dụng cho doanh nghiệp của bạn",
  "templates.noDefault": "Không có mẫu mặc định nào khớp với tìm kiếm của bạn.",
  "templates.noCustom": "Không tìm thấy mẫu tùy chỉnh",
  "templates.delete": "Xóa mẫu",
  "templates.cancel": "Hủy",
  "uploadRequest.notFound": "Không tìm thấy yêu cầu",
  "uploadRequest.error": "Đã xảy ra lỗi",
  "uploadRequest.errorDesc": "Vui lòng thử lại sau hoặc liên hệ với người đã gửi yêu cầu này.",
  "uploadRequest.uploaded": "Tài liệu đã được tải lên!",
  "uploadRequest.title": "Yêu cầu tải lên tài liệu",
  "uploadRequest.fileTypes": "PDF, hình ảnh, tài liệu Word - tối đa 25MB",
  "verify.verifying": "Đang xác minh email của bạn...",
  "verify.success": "Email đã được xác minh!",
  "verify.signIn": "Đăng nhập",
  "verify.alreadyVerified": "Đã được xác minh",
  "verify.invalidLink": "Liên kết không hợp lệ",
  "verify.backToLogin": "Quay lại đăng nhập",
  "documents.documents": "Tài liệu",
  "documents.allStatus": "Tất cả trạng thái",
  "documents.newFolder": "Thư mục mới",
  "documents.clear": "Xóa",
  "documents.noDocumentsYet": "Chưa có tài liệu nào",
  "documents.status": "Trạng thái",
  "documents.type": "Loại",
  "documents.uploadedBy": "Được tải lên bởi",
  "documents.previewNotAvailable": "Không có bản xem trước",
  "documents.aiAnalysis": "Phân tích AI",
  "documents.documentType": "Loại tài liệu",
  "documents.summary": "Tóm tắt",
  "documents.extractedFields": "Trường được trích xuất",
  "documents.issues": "Vấn đề",
  "documents.notYetAnalyzed": "Chưa được phân tích",
  "documents.details": "Chi tiết",
  "documents.size": "Kích thước",
  "documents.date": "Ngày",
  "documents.mimeType": "Loại MIME",
  "documents.noTags": "Không có thẻ",
  "documents.changeStatus": "Thay đổi trạng thái",
  "documents.versionHistory": "Lịch sử phiên bản",
  "documents.noPreviousVersions": "Không có phiên bản trước đó",
  "documents.activityLog": "Nhật ký hoạt động",
  "documents.noActivityRecordedYet": "Chưa ghi nhận hoạt động nào",
  "documents.uploadDocuments": "Tải lên tài liệu",
  "documents.dragAndDropFiles": "Kéo thả tệp hoặc nhấp để duyệt. Hỗ trợ PDF, hình ảnh, tài liệu Word.",
  "documents.shareDocument": "Chia sẻ tài liệu",
  "documents.done": "Hoàn thành",
  "documents.emailOptional": "Email (tùy chọn)",
  "documents.leaveEmptyToJust": "Để trống để chỉ tạo liên kết",
  "documents.messageOptional": "Tin nhắn (tùy chọn)",
  "documents.cancel": "Hủy",
  "documents.requestDocuments": "Yêu cầu tài liệu",
  "documents.sendASecureUpload": "Gửi liên kết tải lên bảo mật cho khách hàng qua email.",
  "documents.clientEmail": "Email khách hàng *",
  "documents.clientName": "Tên khách hàng",
  "documents.requestedDocuments": "Tài liệu được yêu cầu *",
  "documents.renameFolder": "Đổi tên thư mục",
  "documents.selectADestinationFolder": "Chọn thư mục đích.",
  "documents.deleteDocument": "Xóa tài liệu?",
  "settings.individual": "Cá nhân",
  "settings.business": "Doanh nghiệp",
  "settings.buyer": "Người mua",
  "settings.seller": "Người bán",
  "settings.chooseYourPreferredTheme": "Chọn chủ đề ưa thích của bạn",
  "settings.light": "Sáng",
  "settings.dark": "Tối",
  "settings.system": "Hệ thống",
  "settings.manufacturing": "Sản xuất",
  "settings.insurance": "Bảo hiểm",
  "settings.realEstate": "Bất động sản",
  "settings.automotive": "Ô tô",
  "settings.importexport": "Xuất nhập khẩu",
  "settings.other": "Khác",
  "settings.brandingWhitelabel": "Thương hiệu & Nhãn trắng",
  "settings.customizeThePocketfilerExperience": "Tùy chỉnh trải nghiệm PocketFiler cho khách hàng của bạn.",
  "settings.organizationLogo": "Logo tổ chức",
  "settings.provideADirectLink": "Cung cấp liên kết trực tiếp đến logo PNG hoặc SVG trong suốt của bạn.",
  "settings.primaryThemeColor": "Màu chủ đề chính",
  "settings.selectAHexColor": "Chọn mã màu hex để đại diện cho màu nhấn chính của thương hiệu bạn.",
  "settings.accentHoverColor": "Màu nhấn / Di chuột",
  "settings.selectAHexColor1": "Chọn mã màu hex cho trạng thái di chuột, làm nổi bật và các phần tử nhấn.",
  "settings.customDomain": "Tên miền tùy chỉnh",
  "settings.ensureYouConfigureA": "Đảm bảo bạn cấu hình bản ghi CNAME trỏ đến pocketfiler.com.",
  "settings.cancellationScheduled": "Đã lên lịch hủy",
  "settings.yourLastPaymentFailed": "Thanh toán cuối cùng của bạn đã thất bại. Vui lòng cập nhật phương thức thanh toán để tiếp tục truy cập.",
  "settings.chooseYourPlan": "Chọn gói của bạn",
  "settings.monthly": "Hàng tháng",
  "settings.save20": "Tiết kiệm 20%",
  "settings.current": "Hiện tại",
  "settings.popular": "Phổ biến",
  "settings.contactSales": "Liên hệ bán hàng",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Đồng bộ các cuộc họp PocketFiler của bạn với Google Calendar",
  "settings.settingsPageErrorDebug": "Lỗi trang cài đặt (gỡ lỗi)",
  "invoices.createInvoice": "Tạo hóa đơn",
  "invoices.createANewInvoice": "Tạo hóa đơn mới cho khách hàng",
  "invoices.selectClient": "Chọn khách hàng",
  "invoices.dueDate": "Ngày đến hạn",
  "invoices.clientName": "Tên khách hàng",
  "invoices.clientEmail": "Email khách hàng",
  "invoices.lineItems": "Các mục hàng",
  "invoices.description": "Mô tả",
  "invoices.qty": "SL",
  "invoices.price": "Giá",
  "invoices.tax": "Thuế %",
  "invoices.total": "Tổng cộng",
  "invoices.subtotal": "Tổng phụ:",
  "invoices.discount": "Giảm giá:",
  "invoices.tax1": "Thuế:",
  "invoices.total1": "Tổng cộng:",
  "invoices.notesOptional": "Ghi chú (tùy chọn)",
  "invoices.invoices": "Hóa đơn",
  "invoices.manageAndTrackYour": "Quản lý và theo dõi hóa đơn của bạn",
  "invoices.totalInvoiced": "Tổng hóa đơn",
  "invoices.paid": "Đã thanh toán",
  "invoices.outstanding": "Chưa thanh toán",
  "invoices.totalInvoices": "Tổng số hóa đơn",
  "invoices.allInvoices": "Tất cả hóa đơn",
  "invoices.myInvoices": "Hóa đơn của tôi",
  "invoices.receivedInvoices": "Hóa đơn đã nhận",
  "invoices.noInvoicesYet": "Chưa có hóa đơn nào",
  "meetings.join": "Tham gia",
  "meetings.end": "Kết thúc",
  "meetings.meetingTitle": "Tiêu đề cuộc họp",
  "meetings.date": "Ngày",
  "meetings.time": "Thời gian",
  "meetings.duration": "Thời lượng",
  "meetings.repeat": "Lặp lại",
  "meetings.doesNotRepeat": "Không lặp lại",
  "meetings.weekly": "Hàng tuần",
  "meetings.every2Weeks": "Mỗi 2 tuần",
  "meetings.monthly": "Hàng tháng",
  "meetings.invitePeopleOptional": "Mời mọi người (tùy chọn)",
  "meetings.cancel": "Hủy bỏ",
  "meetings.meetings": "Cuộc họp",
  "companyprofile.companyProfile": "Hồ sơ công ty",
  "companyprofile.manageYourBusinessProfile": "Quản lý hồ sơ doanh nghiệp và nhóm của bạn",
  "companyprofile.publicProfile": "Hồ sơ công khai",
  "companyprofile.basicInformation": "Thông tin cơ bản",
  "companyprofile.essentialDetailsAboutYour": "Thông tin chi tiết cần thiết về công ty của bạn",
  "companyprofile.companyName": "Tên công ty",
  "companyprofile.tagline": "Khẩu hiệu",
  "companyprofile.industry": "Ngành nghề",
  "companyprofile.companyType": "Loại hình công ty",
  "companyprofile.description": "Mô tả",
  "companyprofile.companyDetails": "Chi tiết công ty",
  "companyprofile.additionalInformationAboutYour": "Thông tin bổ sung về doanh nghiệp của bạn",
  "companyprofile.yearEstablished": "Năm thành lập",
  "companyprofile.numberOfEmployees": "Số lượng nhân viên",
  "companyprofile.certifications": "Chứng nhận",
  "companyprofile.enterCertificationsSeparatedBy": "Nhập các chứng nhận được phân tách bằng dấu phẩy",
  "companyprofile.languagesSpoken": "Ngôn ngữ sử dụng",
  "companyprofile.shippingRegions": "Khu vực giao hàng",
  "companyprofile.contactInformation": "Thông tin liên hệ",
  "companyprofile.howPotentialPartnersCan": "Cách các đối tác tiềm năng có thể liên hệ với bạn",
  "companyprofile.website": "Website",
  "companyprofile.email": "Email",
  "companyprofile.phone": "Điện thoại",
  "companyprofile.country": "Quốc gia",
  "companyprofile.city": "Thành phố",
  "companyprofile.address": "Địa chỉ",
  "companyprofile.teamMembers": "Thành viên nhóm",
  "companyprofile.manageUsersWithinYour": "Quản lý người dùng trong tổ chức của bạn",
  "companyprofile.role": "Vai trò",
  "companyprofile.admin": "Quản trị viên",
  "companyprofile.member": "Thành viên",
  "companyprofile.viewer": "Người xem",
  "companyprofile.titleOptional": "Chức danh (tùy chọn)",
  "companyprofile.name": "Tên",
  "companyprofile.title": "Chức danh",
  "companyprofile.status": "Trạng thái",
  "companyprofile.actions": "Hành động",
  "companyprofile.owner": "Chủ sở hữu",
  "companyprofile.copyInviteLink": "Sao chép liên kết mời",
  "companyprofile.removeMember": "Xóa thành viên",
  "companyprofile.removeTeamMember": "Xóa thành viên nhóm",
  "companyprofile.cancel": "Hủy bỏ",
  "products.productsServices": "Sản phẩm & Dịch vụ",
  "products.description": "Mô tả",
  "products.pricing": "Giá cả",
  "products.price": "Giá",
  "products.unit": "Đơn vị",
  "products.details": "Chi tiết",
  "products.minOrderQty": "Số lượng đặt hàng tối thiểu",
  "products.leadTime": "Thời gian giao hàng",
  "products.category": "Danh mục",
  "products.currency": "Tiền tệ",
  "products.leadTimeDays": "Thời gian giao hàng (ngày)",
  "products.active": "Hoạt động",
  "products.showInCatalog": "Hiển thị trong danh mục",
  "products.cancel": "Hủy bỏ",
  "developersettings.reveal": "Hiển thị",
  "developersettings.copy": "Sao chép",
  "developersettings.hide": "Ẩn",
  "developersettings.securityWarning": "Cảnh báo bảo mật",
  "developersettings.neverShareThisKey": "Không bao giờ chia sẻ khóa này công khai hoặc trong mã phía client",
  "developersettings.anyoneWithThisKey": "Bất kỳ ai có khóa này đều có thể đọc và sửa đổi dữ liệu của bạn",
  "developersettings.ifCompromisedRevokeImmediately": "Nếu bị xâm phạm, hãy thu hồi ngay lập tức và tạo khóa mới",
  "developersettings.iUnderstandAndAccept": "Tôi hiểu và chấp nhận trách nhiệm bảo mật cho khóa này",
  "developersettings.cancel": "Hủy bỏ",
  "developersettings.revealKey": "Hiển thị khóa",
  "developersettings.accessDenied": "Truy cập bị từ chối",
  "developersettings.onlyBusinessAccountsHave": "Chỉ các tài khoản doanh nghiệp mới có quyền truy cập vào Cài đặt nhà phát triển.",
  "developersettings.developerOverview": "Tổng quan nhà phát triển",
  "developersettings.manageYourApiKeys": "Quản lý khóa API và endpoint Webhook của bạn để tích hợp bên thứ ba.",
  "developersettings.secretApiKeys": "Khóa API bí mật",
  "developersettings.interactiveApiDocumentationRarr": "Tài liệu API tương tác &rarr;",
  "developersettings.name": "Tên",
  "developersettings.key": "Khóa",
  "developersettings.createdAt": "Được tạo vào",
  "developersettings.status": "Trạng thái",
  "developersettings.actions": "Hành động",
  "developersettings.webhookEndpoints": "Endpoint Webhook",
  "developersettings.url": "URL",
  "developersettings.events": "Sự kiện",
  "developersettings.description": "Mô tả",
  "developersettings.done": "Hoàn thành",
  "developersettings.addWebhookEndpoint": "Thêm endpoint Webhook",
  "developersettings.payloadUrl": "URL Payload",
  "developersettings.eventsToSend": "Sự kiện cần gửi",
  "developersettings.sendMeEverything": "Gửi tất cả cho tôi (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Trạng thái Giao dịch Đã thay đổi (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Tài liệu Đã tải lên (document.uploaded)",
  "developersettings.descriptionOptional": "Mô tả (Tùy chọn)",
  "analytics.noDataAvailableFor": "Không có dữ liệu khả dụng cho khoảng thời gian này.",
  "analytics.noDealsFound": "Không tìm thấy giao dịch nào.",
  "analytics.noClientDataAvailable": "Không có dữ liệu khách hàng khả dụng cho khoảng thời gian này.",
  "analytics.client": "Khách hàng",
  "analytics.invoices": "Hóa đơn",
  "analytics.revenue": "Doanh thu",
  "analytics.totalPipeline": "Tổng Pipeline",
  "analytics.noRecentActivityFor": "Không có hoạt động gần đây cho khoảng thời gian này.",
  "analytics.pipelineOverview": "Tổng quan Pipeline",
  "analytics.goToDeals": "Đi đến Giao dịch",
  "analytics.analyticsDashboard": "Bảng điều khiển Phân tích",
  "analytics.trackYourBusinessPerformance": "Theo dõi hiệu suất kinh doanh và thông tin chi tiết của bạn",
  "analytics.last7Days": "7 ngày gần đây",
  "analytics.last30Days": "30 ngày gần đây",
  "analytics.last90Days": "90 ngày gần đây",
  "analytics.lastYear": "Năm ngoái",
  "analytics.overview": "Tổng quan",
  "analytics.myPerformance": "Hiệu suất của tôi",
  "analytics.currentDealsByStatus": "Giao dịch hiện tại theo trạng thái",
  "analytics.revenueTrendsOverLast": "Xu hướng doanh thu trong 6 tháng gần đây",
  "analytics.accountsGeneratingTheMost": "Các tài khoản tạo ra doanh thu nhiều nhất",
  "analytics.currentCashFlowOverview": "Tổng quan dòng tiền hiện tại",
  "analytics.latestBusinessActivitiesAnd": "Hoạt động kinh doanh và cập nhật mới nhất",
  "compliance.complianceCenter": "Trung tâm Tuân thủ",
  "compliance.hsCodesTariffsSanctions": "Mã HS, thuế quan, sàng lọc lệnh trừng phạt và kiểm soát xuất khẩu",
  "compliance.hsCodeClassification": "Phân loại Mã HS",
  "compliance.productDescription": "Mô tả Sản phẩm",
  "compliance.tariffCalculator": "Máy tính Thuế quan",
  "compliance.estimateImportDutiesBased": "Ước tính thuế nhập khẩu dựa trên mã HS và tuyến thương mại.",
  "compliance.hsCode": "Mã HS",
  "compliance.declaredValueUsd": "Giá trị Khai báo (USD)",
  "compliance.originCountry": "Quốc gia Xuất xứ",
  "compliance.destinationCountry": "Quốc gia Đích",
  "compliance.dutyRate": "Thuế suất:",
  "compliance.totalRate": "Tổng thuế suất:",
  "compliance.estDuty": "Thuế Ước tính:",
  "compliance.totalEstCost": "Tổng Chi phí Ước tính:",
  "compliance.tradeAgreements": "Hiệp định Thương mại:",
  "compliance.sanctionsScreening": "Sàng lọc Lệnh trừng phạt",
  "compliance.screenEntitiesAgainstOfac": "Sàng lọc các thực thể đối chiếu với danh sách SDN của OFAC và lệnh trừng phạt quốc gia.",
  "compliance.entityName": "Tên Thực thể",
  "compliance.type": "Loại",
  "compliance.company": "Công ty",
  "compliance.individual": "Cá nhân",
  "compliance.vessel": "Tàu thuyền",
  "compliance.countryOptional": "Quốc gia (tùy chọn)",
  "compliance.usSanctionedCountries": "Các Quốc gia bị Mỹ Trừng phạt",
  "compliance.exportControlCheck": "Kiểm tra Kiểm soát Xuất khẩu",
  "compliance.aipoweredEaritarClassificationGuidance": "Hướng dẫn phân loại EAR/ITAR được hỗ trợ bởi AI. Không phải lời khuyên pháp lý.",
  "compliance.producttechnologyDescription": "Mô tả Sản phẩm/Công nghệ",
  "compliance.hsCodeOptional": "Mã HS (tùy chọn)",
  "compliance.endUseOptional": "Mục đích Sử dụng cuối (tùy chọn)",
  "compliance.licenseRequired": "Yêu cầu Giấy phép",
  "compliance.recommendations": "Khuyến nghị:",
  "compliance.complianceHistory": "Lịch sử Tuân thủ",
  "compliance.recentComplianceChecksFor": "Các kiểm tra tuân thủ gần đây cho tổ chức của bạn.",
  "compliance.noComplianceChecksYet": "Chưa có kiểm tra tuân thủ nào. Thực hiện kiểm tra đầu tiên ở trên.",
  "intelligence.marketIntelligence": "Thông tin Thị trường",
  "intelligence.anonymizedTradeDataAnd": "Dữ liệu thương mại ẩn danh và tiêu chuẩn từ nền tảng PocketFiler",
  "intelligence.demandByCategory": "Nhu cầu theo Danh mục",
  "intelligence.whatBuyersAreSourcing": "Những gì người mua đang tìm nguồn cung trên nền tảng (90 ngày gần đây)",
  "intelligence.noDemandDataYet": "Chưa có dữ liệu nhu cầu. Dữ liệu sẽ được điền khi các RFQ được tạo trên nền tảng.",
  "intelligence.byIndustry": "Theo Ngành",
  "intelligence.noSupplierDataYet": "Chưa có dữ liệu nhà cung cấp.",
  "intelligence.byCountry": "Theo Quốc gia",
  "intelligence.byType": "Theo Loại",
  "intelligence.byVerification": "Theo Xác minh",
  "intelligence.noDataYet": "Chưa có dữ liệu.",
  "intelligence.yourPerformanceVsPlatform": "Hiệu suất của Bạn so với Nền tảng",
  "intelligence.seeHowYouStack": "Xem bạn so sánh như thế nào với mức trung bình của nền tảng",
  "intelligence.completeSomeDealsTo": "Hoàn thành một số giao dịch để xem tiêu chuẩn.",
  "virtualoffices.virtualOffices": "Văn phòng Ảo",
  "virtualoffices.manageYourBrandedWorkspaces": "Quản lý không gian làm việc có thương hiệu của bạn",
  "virtualoffices.officeName": "Tên Văn phòng",
  "virtualoffices.industry": "Ngành",
  "virtualoffices.languagesServed": "Ngôn ngữ Phục vụ",
  "virtualoffices.descriptionOptional": "Mô tả (tùy chọn)",
  "virtualoffices.documentChecklist": "Danh sách Kiểm tra Tài liệu",
  "virtualoffices.languages": "Ngôn ngữ",
  "tasks.tasks": "Nhiệm vụ",
  "tasks.noTasksYet": "Chưa có nhiệm vụ nào",
  "tasks.dragTasksHere": "Kéo nhiệm vụ vào đây",
  "tasks.createNewTask": "Tạo Nhiệm vụ Mới",
  "tasks.descriptionOptional": "Mô tả (Tùy chọn)",
  "tasks.relatedDealOptional": "Giao dịch Liên quan (Tùy chọn)",
  "tasks.noDealAttached": "Không có giao dịch đính kèm",
  "tasks.assignees": "Người được Giao",
  "tasks.noTeamMembersAvailable": "Không có thành viên nhóm khả dụng. Chỉ có thể giao cho các thành viên đang hoạt động.",
  "tasks.cancel": "Hủy",
  "tasks.description": "Mô tả",
  "tasks.status": "Trạng thái",
  "tasks.relatedDeal": "Giao dịch liên quan",
  "tasks.noAssignees": "Không có người được giao",
  "tasks.areYouAbsolutelySure": "Bạn có hoàn toàn chắc chắn không?",
  "events.events": "Sự kiện",
  "events.tradeShowsWebinarsAnd": "Triển lãm thương mại, webinar và sự kiện kết nối",
  "events.createEvent": "Tạo Sự kiện",
  "events.title": "Tiêu đề",
  "events.description": "Mô tả",
  "events.category": "Danh mục",
  "events.type": "Loại",
  "events.locationUrl": "Địa điểm / URL",
  "events.startDateTime": "Ngày & Giờ Bắt đầu",
  "events.endDateTime": "Ngày & Giờ Kết thúc",
  "events.maxAttendeesOptional": "Số Người Tham dự Tối đa (tùy chọn)",
  "events.cancel": "Hủy",
  "events.allCategories": "Tất cả Danh mục",
  "events.noEventsFoundCreate": "Không tìm thấy sự kiện nào. Hãy tạo sự kiện đầu tiên!",
  "events.featured": "Nổi bật",
  "events.previous": "Trước",
  "events.next": "Tiếp theo",
  "status.pendingDocuments": "Chờ tài liệu",
  "status.pendingSignature": "Chờ ký",
  "status.pendingPayment": "Chờ thanh toán",
  "status.completed": "Hoàn thành",
  "status.updated": "Đã cập nhật",
  "status.onHold": "Tạm dừng",
  "activity.deal": "Giao dịch",
  "activity.action.analyzed": "Đã phân tích",
  "activity.action.uploaded": "Đã tải lên",
  "activity.action.downloaded": "Đã tải xuống",
  "activity.action.previewed": "Đã xem trước",
  "activity.action.shared": "Đã chia sẻ",
  "activity.action.status_changed": "Đã thay đổi trạng thái",
  "activity.action.updated": "Đã cập nhật",
  "activity.action.created": "Đã tạo",
  "activity.action.archived": "Đã lưu trữ",
  "activity.action.restored": "Đã khôi phục",
  "analytics.totalRevenue": "Tổng Doanh Thu",
  "analytics.totalDeals": "Tổng Số Giao Dịch",
  "analytics.conversionRate": "Tỷ Lệ Chuyển Đổi",
  "analytics.avgDealValue": "Giá Trị Giao Dịch Trung Bình",
  "analytics.dealPipeline": "Quy Trình Giao Dịch",
  "analytics.monthlyRevenue": "Doanh Thu Hàng Tháng",
  "analytics.topClientsByRevenue": "Khách Hàng Hàng Đầu Theo Doanh Thu",
  "analytics.invoiceHealth": "Tình Trạng Hóa Đơn",
  "analytics.paid": "Đã Thanh Toán",
  "analytics.pendingPayment": "Chờ Thanh Toán",
  "companyprofile.saveProfile": "Lưu Hồ sơ",
  "companyprofile.makeVisible": "Hiển thị công ty của bạn trong danh mục",
  "companyprofile.tab.basicInfo": "Thông tin cơ bản",
  "companyprofile.tab.details": "Chi tiết",
  "companyprofile.tab.contact": "Liên hệ",
  "companyprofile.tab.team": "Nhóm",
  "companyprofile.tab.verification": "Xác minh",
  "companyprofile.selectType": "Chọn loại hình",
  "companyprofile.describePlaceholder": "Mô tả về công ty, sản phẩm và dịch vụ của bạn...",
  "companyprofile.industry.other": "Khác",
  "companyprofile.preview": "Xem trước",
  "companyprofile.ph.companyName": "Your Company Inc.",
  "companyprofile.ph.tagline": "Sản phẩm chất lượng, phạm vi toàn cầu",
  "companyprofile.ph.selectIndustry": "Chọn ngành công nghiệp",
  "companyprofile.ph.selectSize": "Chọn quy mô",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (phân cách bằng dấu phẩy)",
  "companyprofile.ph.languages": "Tiếng Anh, Tiếng Tây Ban Nha, Tiếng Trung",
  "companyprofile.ph.exportRegions": "Bắc Mỹ, Châu Âu, Châu Á",
  "companyprofile.ph.selectCountry": "Chọn quốc gia",
  "companyprofile.ph.city": "Los Angeles",
  "companyprofile.ph.teamName": "Tên thành viên nhóm",
  "companyprofile.ph.addTitle": "Thêm tiêu đề...",
  "companyprofile.inviteTeamMember": "Mời Thành Viên Nhóm",
  "companyprofile.invitationSent": "Đã Gửi Lời Mời Thành Công",
  "virtualoffices.newOffice": "Văn Phòng Mới",
  "virtualoffices.createOffice": "Tạo Văn Phòng Ảo",
  "virtualoffices.reviewChecklist": "Xem Xét Danh Sách Kiểm Tra Tài Liệu",
  "virtualoffices.setupDesc": "Thiết lập không gian làm việc có thương hiệu mới cho doanh nghiệp của bạn",
  "virtualoffices.customizeDesc": "Tùy chỉnh các tài liệu bạn cần từ khách hàng",
  "virtualoffices.ph.officeName": "ví dụ: Garcia Insurance - Auto Policies",
  "virtualoffices.ph.description": "Mô tả trọng tâm của văn phòng bạn...",
  "virtualoffices.ph.addDocument": "Thêm tài liệu tùy chỉnh...",
  "virtualoffices.generating": "Đang tạo...",
  "virtualoffices.aiChecklist": "Danh sách kiểm tra được tạo bởi AI cho",
  "virtualoffices.clients": "Khách Hàng",
  "virtualoffices.pending": "Đang Chờ",
  "virtualoffices.invite": "Mời",
  "virtualoffices.ind.manufacturing": "Sản Xuất",
  "virtualoffices.ind.insurance": "Bảo Hiểm",
  "virtualoffices.ind.real_estate": "Bất Động Sản",
  "virtualoffices.ind.automotive": "Ô Tô",
  "virtualoffices.ind.import_export": "Xuất Nhập Khẩu",
  "virtualoffices.ind.other": "Khác",
  "messages.conversations": "Cuộc trò chuyện",
  "messages.searchPlaceholder": "Tìm kiếm tin nhắn...",
  "messages.noConversations": "Không có cuộc trò chuyện nào",
  "messages.send": "Gửi",
  "messages.selectConversation": "Chọn một cuộc trò chuyện",
  "messages.selectConversationDesc": "Chọn một cuộc trò chuyện từ thanh bên để bắt đầu trò chuyện",
  "messages.support": "Hỗ trợ",
  "messages.client": "Khách hàng",
  "messages.deal": "Giao dịch",
  "meetings.subtitle": "Lên lịch và quản lý các cuộc họp video",
  "meetings.upcoming": "Sắp tới",
  "meetings.past": "Đã qua",
  "meetings.schedule": "Lên lịch",
  "meetings.startInstant": "Bắt đầu ngay",
  "meetings.startNow": "Bắt đầu ngay",
  "meetings.noPast": "Không có cuộc họp nào đã qua",
  "meetings.noUpcoming": "Không có cuộc họp nào sắp tới",
  "meetings.createMeeting": "Tạo cuộc họp",
  "meetings.startInstantMeeting": "Bắt đầu cuộc họp ngay",
  "meetings.scheduleMeeting": "Lên lịch cuộc họp",
  "meetings.scheduleDesc": "Lên lịch một cuộc họp video và gửi lời mời.",
  "meetings.invitePeople": "Mời người tham gia (tùy chọn)",
  "meetings.15min": "15 phút",
  "meetings.30min": "30 phút",
  "meetings.45min": "45 phút",
  "meetings.allowRecording": "Cho phép ghi âm",
  "meetings.recordingDesc": "Cho phép người chủ trì ghi âm cuộc họp này",
  "meetings.waitingRoom": "Phòng chờ",
  "meetings.waitingRoomDesc": "Người tham gia phải được chấp nhận bởi người chủ trì trước khi tham gia",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "Hủy cuộc họp này?",
  "meetings.cancelMeeting": "Hủy cuộc họp",
  "documents.title": "Tài liệu",
  "documents.viewAll": "Xem tất cả",
  "documents.archived": "Đã lưu trữ",
  "documents.requestDocs": "Yêu cầu tài liệu",
  "documents.upload": "Tải lên",
  "documents.allDocuments": "Tất cả tài liệu",
  "documents.searchPlaceholder": "Tìm kiếm tài liệu...",
  "documents.addTag": "Thêm thẻ...",
  "documents.uploadDesc": "Kéo thả tệp hoặc nhấp để duyệt. Hỗ trợ PDF, hình ảnh, tài liệu Word.",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "Đây là tài liệu bạn đã yêu cầu...",
  "documents.requestDesc": "Gửi liên kết tải lên an toàn đến khách hàng qua email.",
  "documents.namePlaceholder": "Nguyễn Văn A",
  "documents.requestMsgPlaceholder": "Vui lòng tải lên các tài liệu sau...",
  "documents.folderName": "Tên thư mục",
  "documents.selectDestination": "Chọn thư mục đích.",
  "documents.statusUploaded": "Đã tải lên",
  "documents.statusAnalyzed": "Đã phân tích",
  "documents.statusArchived": "Đã lưu trữ",
  "documents.allTypes": "Tất cả loại",
  "documents.inArchive": "trong kho lưu trữ",
  "templates.allTemplates": "Tất cả Mẫu",
  "templates.editTemplate": "Chỉnh sửa Mẫu",
  "templates.createCustomTemplate": "Tạo Mẫu Tùy chỉnh",
  "templates.editDesc": "Cập nhật mẫu tài liệu của bạn",
  "templates.createDesc": "Tạo mẫu tài liệu có thể tái sử dụng của riêng bạn",
  "templates.ph.templateName": "ví dụ: NDA Tùy chỉnh",
  "templates.ph.description": "Mô tả ngắn gọn về mẫu",
  "templates.ph.content": "Nhập nội dung mẫu của bạn tại đây...",
  "templates.saving": "Đang lưu...",
  "templates.creating": "Đang tạo...",
  "templates.saveChanges": "Lưu Thay đổi",
  "templates.createTemplate": "Tạo Mẫu",
  "templates.searchPlaceholder": "Tìm kiếm mẫu...",
  "templates.popularTemplates": "Mẫu Phổ biến",
  "templates.defaultTemplates": "Mẫu Mặc định",
  "templates.deleteTemplate": "Xóa Mẫu",
  "templates.preview": "Xem trước",
  "templates.description": "Mô tả",
  "products.searchPlaceholder": "Tìm kiếm sản phẩm...",
  "products.ph.service": "Dịch vụ tư vấn",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "Chọn danh mục",
  "products.ph.describe": "Mô tả sản phẩm hoặc dịch vụ của bạn...",
  "products.noMatches": "Không tìm thấy kết quả phù hợp",
  "products.noProducts": "Chưa có sản phẩm hoặc dịch vụ nào",
  "products.serviceDetails": "Chi tiết dịch vụ",
  "products.productDetails": "Chi tiết sản phẩm",
  "products.inactive": "Không hoạt động",
  "products.deleteConfirm": "Xóa mục này?",
  "products.saveChanges": "Lưu thay đổi",
  "products.addItem": "Thêm mục",
  "products.priceOnRequest": "Giá theo yêu cầu",
  "products.perUnit": "Trên mỗi đơn vị",
  "tasks.searchPlaceholder": "Tìm kiếm nhiệm vụ...",
  "tasks.ph.title": "ví dụ: Xem xét tài liệu pháp lý",
  "tasks.ph.description": "Thêm ngữ cảnh cho nhiệm vụ này...",
  "tasks.selectDeal": "Chọn thỏa thuận để đính kèm",
  "tasks.noTasks": "Không có nhiệm vụ nào trong cột này",
  "tasks.deleteTask": "Xóa nhiệm vụ",
  "settings.tabs.branding": "Thương hiệu",
  "settings.tabs.payments": "Thanh toán",
  "settings.tabs.plan": "Gói dịch vụ",
  "settings.tabs.integrations": "Tích hợp",
  "settings.appearance": "Giao diện",
  "settings.saveBranding": "Lưu thương hiệu",
  "settings.yourPlan": "Gói dịch vụ của bạn",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "URL nguồn cấp dữ liệu lịch đã được tạo!",
  "settings.plan.free": "Miễn phí",
  "settings.plan.pro": "Chuyên nghiệp",
  "settings.plan.smallBusiness": "Doanh nghiệp nhỏ",
  "settings.plan.businessPro": "Doanh nghiệp chuyên nghiệp",
  "settings.plan.scale": "Mở rộng",
  "settings.plan.enterprise": "Doanh nghiệp lớn",
  "dealroom.meetings": "Các cuộc họp",
  "dealroom.startMeeting": "Bắt đầu cuộc họp",
  "dealroom.noMeetings": "Chưa có cuộc họp nào được liên kết với thỏa thuận này",
  "dealroom.noMeetingsDesc": "Bắt đầu một cuộc họp hoặc lên lịch một cuộc họp để khởi đầu",
  "dealroom.failedCreateMeeting": "Không thể tạo cuộc họp",
  "dealroom.finalizedContract": "Hợp đồng đã hoàn thiện — Sẵn sàng để ký",
  "dealroom.previewNotSupported": "Không hỗ trợ xem trước",
  "dealroom.aiMayTakeMoment": "Quá trình này có thể mất một chút thời gian.",
  "dealroom.aiAnalysisGenerated": "Phân tích AI đã được tạo cho các tài liệu sau:",
  "dealroom.docsUnanalyzed": "Các tài liệu sau vẫn chưa được phân tích:",
  "dealroom.analyzingDocs": "Đang phân tích tài liệu...",
  "dealroom.finalizeWarning": "Hành động này không thể hoàn tác. Trạng thái thỏa thuận sẽ chuyển thành Chờ ký và tất cả các bên sẽ có thể ký hợp đồng.",
  "dealroom.cannotRevert": "Không thể hoàn tác từ trạng thái Chờ ký",
  "compliance.ph.productDesc": "ví dụ: Bulong inox, M10 x 50mm...",
  "compliance.ph.exportDesc": "Mô tả sản phẩm hoặc công nghệ được xuất khẩu...",
  "compliance.select": "Chọn...",
  "compliance.selectCountry": "Chọn quốc gia...",
  "events.tradeShow": "Hội chợ thương mại",
  "events.webinar": "Hội thảo trực tuyến",
  "events.networking": "Kết nối",
  "events.conference": "Hội nghị",
  "events.workshop": "Hội thảo",
  "events.ph.title": "Tiêu đề sự kiện",
  "events.ph.location": "Địa chỉ địa điểm hoặc URL cuộc họp",
  "events.ph.maxAttendees": "Để trống để không giới hạn",
  "events.searchPlaceholder": "Tìm kiếm sự kiện...",
  "events.cancelRsvp": "Hủy RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "Đã hết hạn",
  "rfq.createRfq": "Tạo yêu cầu báo giá",
  "rfq.visibility": "Mức độ hiển thị",
  "rfq.public": "Công khai - Tất cả nhà cung cấp có thể xem",
  "rfq.private": "Riêng tư - Chỉ theo lời mời",
  "rfq.quantity": "Số lượng",
  "rfq.unit": "Đơn vị",
  "rfq.pieces": "Miếng",
  "rfq.kilograms": "Kilôgam",
  "rfq.meters": "Mét",
  "rfq.squareMeters": "Mét vuông",
  "rfq.units": "Đơn vị",
  "rfq.sets": "Bộ",
  "rfq.boxes": "Hộp",
  "rfq.deliveryLocation": "Địa điểm giao hàng",
  "rfq.deliveryDeadline": "Thời hạn giao hàng",
  "rfq.specialRequirements": "Yêu cầu đặc biệt",
  "rfq.title": "Yêu cầu báo giá",
  "rfq.subtitle": "Duyệt các yêu cầu tìm nguồn cung hoặc đăng yêu cầu của bạn",
  "rfq.rfqsPosted": "RFQ đã đăng",
  "rfq.openRfqs": "RFQ đang mở",
  "rfq.quotesSent": "Báo giá đã gửi",
  "rfq.winRate": "Tỷ lệ thắng",
  "rfq.allCategories": "Tất cả danh mục",
  "rfq.noRfqsFound": "Không tìm thấy RFQ",
  "rfq.noRfqsYet": "Chưa có RFQ",
  "meetings.biweekly": "2 tuần một lần",
  "meetings.cancelSeries": "Hủy toàn bộ chuỗi",
  "meetings.cancelThisMeeting": "Hủy cuộc họp này",
  "meetings.nextInSeries": "Tiếp theo trong chuỗi",
  "nav.contractTemplates": "Hợp đồng",
  "contracts.title": "Mẫu Hợp đồng",
  "contracts.subtitle": "Tạo tài liệu pháp lý bằng AI. Chọn mẫu để bắt đầu.",
  "documents.create": "Tạo mới",
  "createDoc.untitledDocument": "Tài liệu chưa đặt tên",
  "createDoc.save": "Lưu",
  "createDoc.export": "Xuất",
  "createDoc.aiAssist": "Trợ lý AI",
  "createDoc.generate": "Tạo",
  "createDoc.generating": "Đang tạo...",
  "createDoc.cancel": "Hủy",
  "createDoc.translate": "Dịch",
  "createDoc.translateTitle": "Dịch Tài liệu",
  "createDoc.translateTo": "Dịch sang",
  "createDoc.translateNow": "Dịch",
  "createDoc.translating": "Đang dịch...",
  "createDoc.translated": "Dịch tài liệu thành công",
  "createDoc.translateFailed": "Dịch thất bại",
  "verification.status": "Trạng thái xác minh",
  "verification.inProgress": "Đang xác minh",
  "verification.getVerified": "Xác minh",
  "verification.cancelRequest": "Hủy yêu cầu",
  "verification.submit": "Gửi xác minh",
  "verification.submitting": "Đang gửi...",
  "verification.uploadDocs": "Tải lên tài liệu",
  "verification.level": "Cấp độ xác minh",
  "verification.selectDocType": "Chọn loại tài liệu...",
  "contracts.generate": "Tạo",
  "contracts.backToTemplates": "Quay lại mẫu",
  "contracts.required": "Bắt buộc",
  "contracts.modify": "Chỉnh sửa",
  "contracts.finalize": "Hoàn tất",
  "contracts.applyChanges": "Áp dụng thay đổi",
  "contracts.confirmDelete": "Xóa bản nháp này?",
  "contracts.generating": "Đang tạo tài liệu...",
  "templates.deleting": "Đang xóa...",
  "templates.noDescription": "Không có mô tả.",
  "templates.use": "Sử dụng",
  "templates.lib.ndaMutual": "Thỏa thuận bảo mật hai chiều",
  "templates.lib.purchaseAgreement": "Hợp đồng mua bán",
  "templates.lib.serviceAgreement": "Hợp đồng dịch vụ",
  "templates.lib.priceQuote": "Báo giá",
  "templates.lib.invoice": "Hóa đơn",
  "templates.lib.loi": "Thư bày tỏ ý định",
  "settings.security": "Bảo mật",
  "security.twoFactor": "Xác thực hai yếu tố",
  "security.enabled": "Đã bật",
  "security.disabled": "Đã tắt",
  "security.enable2FA": "Bật 2FA",
  "security.disable": "Tắt",
  "security.activeSessions": "Phiên hoạt động",
  "security.logoutAll": "Đăng xuất tất cả",
  "security.loginHistory": "Lịch sử đăng nhập",
  "security.verify": "Xác minh",
  "security.cancel": "Hủy",
  "security.password": "Mật khẩu",
  "security.done": "Xong",
  "feedback.button": "Phản hồi",
  "feedback.title": "Gửi Phản hồi",
  "feedback.typeBug": "Lỗi",
  "feedback.typeFeature": "Tính năng",
  "feedback.typeGeneral": "Chung",
  "feedback.submit": "Gửi",
  "feedback.thanks": "Cảm ơn! Chúng tôi sẽ xem xét.",
};

export default vi;